import React from 'react';
import PropTypes from 'prop-types';
import './Switch.scss';

const Switch = ({ checked = false, onChange, disabled = false, labelStyles = {}, ...otherProps }) => {
  return (
    <label className="switch" style={{ ...labelStyles }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...otherProps}
      />
      <span className="slider round" style={{ cursor: disabled ? 'auto' : 'pointer' }}></span>
    </label>
  );
};

Switch.protoTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Switch;
